import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SeOrgAvatarModule, SePersonaAvatarModule } from '@se-ui-components'

import { HeaderComponent } from './header/header.component'
import { FooterComponent } from './footer/footer.component'
import { SubfooterComponent } from './subfooter/subfooter.component'

@NgModule({
  declarations: [HeaderComponent, FooterComponent, SubfooterComponent],
  imports: [CommonModule, SeOrgAvatarModule, SePersonaAvatarModule],
  exports: [HeaderComponent, FooterComponent, SubfooterComponent],
})
export class LayoutModule { }
